import React from 'react';
import { Typography, CircularProgress } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { CellMeasurer, List, AutoSizer } from 'react-virtualized';

import EmptyImage from '../../assets/images/empty.svg';
import NotificationItem from './../ManagerNotificationItem';
import firstLetterToUpperCase from '../../shared/firstLetterToUpperCase';

import {
  Container,
  Header,
  AddButton,
  GoBack,
  NoNotificationContent,
  NoItemsImage,
  NoItemsText,
  NoItemsHelperText,
  NotificationDetailText,
  DetailCategory,
  Names,
  DetailsContainer,
} from './styles';

export default function ({
  items,
  newNotification,
  loading,
  cache,
}) {
  const isEmpty = items.length === 0;
  const [selectedItem, toggleItem] = React.useState(null);

  function renderItem({ index, parent, style }) {
    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={items[index].id}
        parent={parent}
        rowIndex={index}
      >
        {({ registerChild }) => (
          <div key={items[index].id} ref={registerChild} style={style}>
            <Divider />
            <NotificationItem {...items[index]} onItemClick={() => toggleItem(items[index])} />
          </div>
        )}
      </CellMeasurer>
    );
  }

  function formatNames(names) {
    const namesCapitalized = names.toLowerCase()
      .split(' ')
      .map(string => firstLetterToUpperCase(string))
      .join(' ')
      .replace(/,\s*$/, '.');

    return namesCapitalized;
  }

  return (
    <Container loading={loading}>
      {loading ? <CircularProgress style={{ margin: 'auto' }} /> : (
        <>
          <Header>
            { !selectedItem ? (
              <>
                <Typography style={{ color: 'black' }}>
                  Notificações enviadas
                </Typography>
                <AddButton onClick={newNotification} />
              </>
            ) : (
              <>
                <GoBack onClick={() => toggleItem(null)} />
                <NotificationDetailText>
                  Detalhes
                </NotificationDetailText>
              </>
            )}
          </Header>

          {(!isEmpty && !selectedItem) && (
            <AutoSizer>
              {({ width }) => (
                <List
                  width={width}
                  height={330}
                  rowRenderer={renderItem}
                  rowCount={items.length}
                  deferredMeasurementCache={cache}
                  rowHeight={cache.rowHeight}
                />
              )}
            </AutoSizer>
          )}

          {(isEmpty && !selectedItem) && (
            <>
              <Divider />
              <NoNotificationContent>
                <NoItemsImage src={EmptyImage} alt="Nenhuma notificação" width="70%" />
                <NoItemsText color="primary">
                  Nenhuma notificação enviada
                </NoItemsText>
                <NoItemsHelperText color="primary">
                  Envie notificações para seus funcionários
                </NoItemsHelperText>
              </NoNotificationContent>
            </>
          )}

          {
            selectedItem && (
              <DetailsContainer>
                {selectedItem.details.read.length > 0 &&
                  <DetailCategory>
                    Leu
                    <Names>
                      {formatNames(selectedItem.details.read)}
                    </Names>
                  </DetailCategory>
                }

                {selectedItem.details.received.length > 0 &&
                  <DetailCategory>
                    Recebeu
                    <Names>
                      {formatNames(selectedItem.details.received)}
                    </Names>
                  </DetailCategory>
                }

                {selectedItem.details.pending.length > 0 &&
                  <DetailCategory>
                    Não recebeu
                    <Names>
                      {formatNames(selectedItem.details.pending)}
                    </Names>
                  </DetailCategory>
                }
              </DetailsContainer>
            )
          }
        </>
      )}
    </Container>
  );
}
